import { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import { AssignUserToWebsite } from '../services/authService';

const AssignUserToWebsiteForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    website: '',
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await AssignUserToWebsite(formData);

      if (response.status === 200) {
        toast.success('User assigned to website successfully!');
        setFormData({ email: '', website: '' }); // clear form
      } else {
        toast.error('failed.');
      }
    } catch (err) {
      console.error(err);
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        'Something went wrong!';
      toast.error(message);
    }
  };

  return (
    <div>
      <h2>Assign User to Website</h2>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="formEmail">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter user email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formWebsite">
          <Form.Label>Website</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter website name"
            name="website"
            value={formData.website}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Button variant="primary" type="submit">
          Assign
        </Button>
      </Form>
    </div>
  );
};

export default AssignUserToWebsiteForm;
